import { __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import TooltipDecoratorClass from '../Tooltip/TooltipDecorator.js';

var defaultStyles = {
    cursor: 'initial',
};
var DivTooltip = React__default.forwardRef(function (_a, ref) {
    var className = _a.className, onClick = _a.onClick; _a.position; var style = _a.style, children = _a.children, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onMouseMove = _a.onMouseMove; _a.fixed;
    return (jsx("div", { ref: ref, className: "".concat(className ? " ".concat(className) : ''), style: style ? __assign(__assign({}, defaultStyles), style) : __assign({}, defaultStyles), onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, children: children }));
});
var DivTooltip$1 = TooltipDecoratorClass()(DivTooltip);

export { DivTooltip$1 as default };
//# sourceMappingURL=DivTooltip.js.map
